export default "__VITE_ASSET__CAsbcKqL__"